<script lang="ts">
  import Sprite from "./sprite.svelte";

  export let label = "";
  export let context = "";
  export let icon = "";
  export let href: string;
</script>

<a class="type-caption" {href} aria-label={context}>
  {label}
  {#if icon}
    <Sprite {icon} />
  {/if}
</a>

<style>
  a {
    display: flex;
    text-decoration: none;
    font-weight: 600;
    line-height: 24px;
  }

  a :global(svg) {
    margin-left: 4px;
  }
</style>
